var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ContentCommunicationHandler } from '../communications/index';
/**
 * @inheritdoc
 */
var InWindowContentCommunicationHandler = /** @class */ (function (_super) {
    __extends(InWindowContentCommunicationHandler, _super);
    /**
     * Constructor.
     *
     * @param el The element to use for sending and receiving messages.
     * @param methods The callback to dispose the content.
     */
    function InWindowContentCommunicationHandler(communicationsManager, methods) {
        return _super.call(this, communicationsManager, methods) || this;
    }
    return InWindowContentCommunicationHandler;
}(ContentCommunicationHandler));
export { InWindowContentCommunicationHandler };
//# sourceMappingURL=contentCommunicationHandler.js.map